import React, {
  useMemo,
} from 'react';
import { FieldComponent } from '../../../types/FieldComponent';
import { compareDate } from '../comparators/compareDate';
import { DateFilter } from '../filters/DateFilter';
import 'dayjs/locale/en-gb';

export const DateTimeField: FieldComponent<
  string,
  string[],
  { loading?: boolean }
> = ({
  onChange,
  isActive,
  value,
  loading,
  intent,
  hasTooltip,
  disabled,
  mui,
  width,
  isMissing,
  compact,
}) => {
  return (
    <>

    </>
  );

};

DateTimeField.includes = (query = [], value) =>
  query.length === 0 ||
  (value !== undefined &&
    query.some((date) => compareDate(new Date(date), new Date(value)) === 0));

DateTimeField.comparator = (one = '', other = '') => {
  if (one === other) return 0;
  return one < other ? -1 : 1;
};

DateTimeField.FilterRenderer = DateFilter;
